import React from 'react';
import Header from '../../uiParts/menu/Header';
import { Typography } from '@mui/material';
import { gray100, gray20 } from '../../../constants/colors';
import { spHeaderHeight, headerHeight } from '../../../constants/location';
import MetaTitle from '../../utils/MetaTitle';

const styles = {
  container: {
    backgroundcolor: gray20,
    '@media screen and (max-width:600px)': {
      height: `calc( 100vh - ${spHeaderHeight} - 120px)`,
      m: `${spHeaderHeight} auto 0`,
      pt: '120px',
      width: '90%',
    },
    height: `calc( 100vh - ${headerHeight} -  176px )`,
    m: `${headerHeight} auto 0`,
    pt: '176px',
    width: '560px',
  },
  text: {
    fontSize: '16px',
    color: gray100,
    mt: '8px',
    textAlign: 'center',
  },
  textDesctiprion: {
    fontSize: '16px',
    color: gray100,
    mt: '48px',
    textAlign: 'center',
  },
  title: {
    color: gray100,
    fontSize: '36px',
    fontWeight: '400',
    textAlign: 'center',
  },
};

const NotFound = (): JSX.Element => {
  return (
    <>
      <MetaTitle />
      <Header />
      <Typography component="div" sx={styles.container}>
        <Typography sx={styles.title}>404 Not Found</Typography>
        <Typography sx={styles.text}>お探しのページは見つかりませんでした</Typography>
        <Typography sx={styles.textDesctiprion}>
          アクセスしようとしたページは削除されたかURLが変更されているため、
          <br />
          見つけることができません。
        </Typography>
      </Typography>
    </>
  );
};

export default NotFound;
